import * as THREE from 'three/webgpu';
import {pass, toneMapping, vec4} from "three/tsl";
import {bloom} from "three/addons/tsl/display/BloomNode.js";
import Experience from "./Experience.js";

export default class Renderer {
    constructor() {
        this.experience = new Experience();
        this.canvas = this.experience.canvas;
        this.sizes = this.experience.sizes;
        this.scene = this.experience.scene;
        this.camera = this.experience.camera;
        this.debug = this.experience.debug;
        
        if (this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder('Post Processing').open();
        }
        
        this.postProcessingParams = {
            enable: true,
            threshold: 0.1,
            strength: 0.7,
            radius: 0.3,
            exposure: 1,
            toneMapping: THREE.ACESFilmicToneMapping
        };
    }

    async init() {
        this.instance = new THREE.WebGPURenderer( );
        await this.instance.init();
        this.instance.shadowMap.enabled = true;
        this.instance.shadowMap.type = THREE.PCFSoftShadowMap;
        this.instance.setSize(this.sizes.width, this.sizes.height);
        this.instance.setPixelRatio(this.sizes.pixelRatio);
        
        // Add generated canvas do dom
        // Hint: this.canvas is only a div container where the
        // canvas is now being appended
        this.canvas.appendChild(this.instance.domElement);
        
        this.setupPostProcessing();
        this.setDebug();
    }
    
    setupPostProcessing() {
        // Post-processing
        this.postProcessing = new THREE.PostProcessing(this.instance);
        const scenePass = pass(this.scene, this.camera.instance);
        const scenePassColor = scenePass.getTextureNode();
        const bloomPass = bloom(
            scenePassColor,
            this.postProcessingParams.strength,
            this.postProcessingParams.radius
        );

        const composition = scenePassColor.add(bloomPass);

        const finalOutput = toneMapping(
            this.postProcessingParams.toneMapping,
            2, // Use standard exposure
            composition
        );

        this.postProcessing.outputNode = vec4(finalOutput.rgb, 1.0);
    }
    
    resize() {
        this.instance.setSize(this.sizes.width, this.sizes.height);
        this.instance.setPixelRatio(this.sizes.pixelRatio);
    }
    
    update() {
        if (this.postProcessingParams.enable) {
            this.postProcessing.render();
            return;
        }
        
        this.instance.render(this.scene, this.camera.instance);
    }
    
    setDebug() {
        if (!this.debug.active)
        {
            return;
        }
        this.debugFolder.add(this.postProcessingParams, 'enable').name('Enable');
    }
}